import * as React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { colors, fonts } from "../../styles";
interface Props {
  ballance: number | string | null;
}

const SBannerWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  position: relative;
`;

const BalanceText = styled.p`
  color: rgb(${colors.white});
  font-size: ${fonts.size.h3};
  // font-family: "NexaDemo-Bold";
  margin: 0 0.3em;
  text-align: center;
  @media screen and (max-width: 768px) {
    font-size: ${fonts.size.h5};
  }
`;
const BalanceValue = styled.p`
  color: rgb(${colors.white});
  font-size: ${fonts.size.h3};
  // font-family: "NexaDemo-Bold";
  margin: 0 0.3em;
  text-align: center;
  @media screen and (max-width: 768px) {
    font-size: ${fonts.size.h5};
  }
`;

const Balance: React.FC<Props> = ({ ballance }) => {
  const { t } = useTranslation();
  return (
    <SBannerWrapper>
      <BalanceText>{`${t("BV3ABalance")}: `}</BalanceText>
      <BalanceValue>{ballance}</BalanceValue>
    </SBannerWrapper>
  );
};

export default Balance;
